import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { config, userConfig } from '@/store';

/**
* 根据反转设置项 如无反转则前翻译 有反转则向后翻页
*/

const __default__ = { name: 'operation-cover' };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  emits: [
	'before',
	'next',
	'switchMenu',
	'switchFooter',
],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

let do_left = computed(() => {
	return userConfig.pageTurningReverse ? next : before;
})

let do_right = computed(() => {
	return userConfig.pageTurningReverse ? before : next;
})

let topStyle = computed(() => {
	const height = userConfig.browseOperationTop + '%';
	return { height };
})

let bottomStyle = computed(() => {
	const height = userConfig.browseOperationBottom + '%';
	return { height };
})


const emit = __emit;

function before() {
	emit('before');
}
function next() {
	emit('next');
}
function switch_menu() {
	emit('switchMenu');
}
function switch_footer() {
	emit('switchFooter');
}
function context_menu() {
	config.rightSidebar = true;
}


const __returned__ = { get do_left() { return do_left }, set do_left(v) { do_left = v }, get do_right() { return do_right }, set do_right(v) { do_right = v }, get topStyle() { return topStyle }, set topStyle(v) { topStyle = v }, get bottomStyle() { return bottomStyle }, set bottomStyle(v) { bottomStyle = v }, emit, before, next, switch_menu, switch_footer, context_menu, get config() { return config } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})